import React from 'react';
import { useIntl } from 'react-intl';
import BaseModal from 'src/components/BaseModal';
import { BaseModalProps } from 'src/components/BaseModal/BaseModal';
import ConnectedAppsPanel from './ConnectedAppsPanel';
import messages from './messages';

type Props = BaseModalProps & {
  /** One member's apps; omit for every member of the account. */
  user?: { id: number; email: string };
};

/** Admin view of connected apps, opened from the Users page. */
const ConnectedAppsModal = ({ user, ...rest }: Props) => {
  const { formatMessage } = useIntl();
  return (
    <BaseModal {...rest}>
      <h3>
        {user
          ? formatMessage(messages.modalTitleUser, { email: user.email })
          : formatMessage(messages.modalTitleAccount)}
      </h3>
      <ConnectedAppsPanel scope={user ? { kind: 'user', userId: user.id } : { kind: 'account' }} />
    </BaseModal>
  );
};

export default ConnectedAppsModal;
